export default __webpack_public_path__ + "static-front/media/CertificateIcon.5d2cdc37.svg";